import { loadScript } from './loadScript.js';
import { BOM } from './BOM.js';
import { addTapEvent, hasClass, bubble } from './DOM.js';
//BOM.window.TDAPP = BOM.window.TDAPP || { onEvent(){}  };
function Tracker(event, label, params = {}) {
    const _event = event || 'no';
    this.event = _event;
    this.tryCount = 3;
    loadScript(`https://jic.talkingdata.com/app/h5/v1?appid=EF6EF1136C2E4B74B8F39CBC8ED64950&vn=Pokekara&vc=1.0.1`, () => {
        if (label) {
            try {
                if(typeof params==='object') {
                    BOM.window.TDAPP.onEvent(event, label, { label: label, ...params });
                }else {
                    BOM.window.TDAPP.onEvent(event, label, { label: label });
                }
            } catch (e) {
                BOM.log(e);
            }
        }
        addTapEvent(document.body, e => {
            bubble(
                e.target,
                elem => {
                    if (hasClass(elem, 'jstracker')) {
                        return true;
                    }
                },
                elem => {
                    const paramstr = elem.getAttribute('param');
                    if (paramstr) {
                        const param = new Function('return' + paramstr)();
                        this.track(param.event || _event, param.action || param.label);
                    }
                }
            );
        });
    });
}

Tracker.prototype.track = function(arg1, arg2, arg3) {
    try {
        if (arg3) {
            BOM.window.TDAPP.onEvent(arg1, arg2, { label: arg2, ...arg3 });
        } else if (arg2) {
            if (typeof arg2 === 'object') {
                BOM.window.TDAPP.onEvent(this.event, arg1, { label: arg1, ...arg2 });
            } else {
                BOM.window.TDAPP.onEvent(arg1, arg2, { label: arg2 });
            }
        } else {
            BOM.window.TDAPP.onEvent(this.event, arg1, { label: arg1 });
        }
    } catch (e) {
        BOM.log(e);
        if (this.tryCount > 0) {
            setTimeout(() => {
                this.tryCount--;
                this.track(...arguments);
            }, 3000);
        }
    }
};

export { Tracker };
